// src/redux/stockerSignal/stockerSignalSlice.js
import { createSlice } from "@reduxjs/toolkit";
import { fetchStockerSignal } from "./stockerSignalActions";

const initialState = {
  byTicker: {},   // { AAPL: { loading, error, data } }
  lastUpdated: {}, // { AAPL: timestamp }
};

const stockerSignalSlice = createSlice({
  name: "stockerSignal",
  initialState,
  reducers: {
    clearStockerSignal(state, action) {
      const ticker = action.payload;
      delete state.byTicker[ticker];
      delete state.lastUpdated[ticker];
    },
  },
  extraReducers: (builder) => {
    builder
      // ---- Pending ----
      .addCase(fetchStockerSignal.pending, (state, action) => {
        const { ticker } = action.meta.arg;

        if (!state.byTicker[ticker]) {
          state.byTicker[ticker] = { data: null, loading: true, error: null };
        } else {
          state.byTicker[ticker].loading = true;
          state.byTicker[ticker].error = null;
        }
      })

      // ---- Fulfilled ----
      .addCase(fetchStockerSignal.fulfilled, (state, action) => {
        const { ticker, data } = action.payload;

        state.byTicker[ticker] = {
          data,
          loading: false,
          error: null,
        };
        state.lastUpdated[ticker] = Date.now();
      })

      // ---- Rejected ----
      .addCase(fetchStockerSignal.rejected, (state, action) => {
        const { ticker } = action.meta.arg;

        state.byTicker[ticker] = {
          data: null,
          loading: false,
          error: action.payload || "Failed to load Stocker Signal",
        };
      });
  },
});

export const { clearStockerSignal } = stockerSignalSlice.actions;

export default stockerSignalSlice.reducer;
